module.exports = __webpack_public_path__ + "img/shi.639b3d5e.png";